import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {GameInfoModuleTerms} from "./game-info-module.terms";

export class GameInfoModuleConfig extends BaseConfig {

  static injectables = [GameInfoModuleTerms];

  constructor(terms: GameInfoModuleTerms){
    super('gameInfoModule', null, terms);
  }
}
